import { render, staticRenderFns } from "./IepUnity.vue?vue&type=template&id=23705b0c&scoped=true"
import script from "./IepUnity.vue?vue&type=script&lang=js"
export * from "./IepUnity.vue?vue&type=script&lang=js"
import style0 from "./IepUnity.vue?vue&type=style&index=0&id=23705b0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23705b0c",
  null
  
)

export default component.exports